import "./About.scss";
import { Content } from "antd/es/layout/layout";
import { theme } from "antd";
import {
  SafetyOutlined,
  GlobalOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { MissionCard, TechnologyCard, UnderstandingCard } from "./components";
import {
  HeroCard,
  FeatureCard,
  BenefitsCard,
  ContactUs,
} from "../../components";

export default function About() {
  const { useToken } = theme;
  const { token } = useToken();

  const heroData = {
    icon: (
      <HeartOutlined style={{ color: token?.icons?.whiteIcon, fontSize: 40 }} />
    ),
    title: "About BlackList420",
    description:
      "We're revolutionizing healthcare safety through innovative technology. Our mission is to create a transparent, secure platform that protects healthcare providers and patients by sharing critical information about problematic individuals—all while maintaining the highest standards of privacy and ethical responsibility.",
  };

  const features = [
    {
      icon: <SafetyOutlined />,
      title: "Secure & Transparent",
      description: "Built with security and transparency at its core",
    },
    {
      icon: <GlobalOutlined />,
      title: "Decentralized",
      description: "Leveraging modern decentralized technologies",
    },
    {
      icon: <TeamOutlined />,
      title: "Community-Driven",
      description: "Powered by the community, for the community",
    },
    {
      icon: <ThunderboltOutlined />,
      title: "Real-Time Updates",
      description: "Stay informed with instant data synchronization",
    },
  ];

  const impactPoints = [
    {
      icon: (
        <CheckCircleOutlined style={{ color: token?.colorSecondaryLogo }} />
      ),
      text: "Maintains security and ethical standards across industries",
    },
    {
      icon: (
        <CheckCircleOutlined style={{ color: token?.colorSecondaryLogo }} />
      ),
      text: "Protects users from cyber threats and malicious activities",
    },
    {
      icon: (
        <CheckCircleOutlined style={{ color: token?.colorSecondaryLogo }} />
      ),
      text: "Prevents fraud and unethical behavior in business",
    },
    {
      icon: <WarningOutlined style={{ color: token?.colorWarning }} />,
      text: "Requires transparency and fairness to prevent misuse",
    },
  ];

  return (
    <Content className="about-cont">
      {/* Hero Section */}
      <HeroCard token={token} {...heroData} />

      {/* Features Section */}
      <div className="about-cont__features">
        {features?.map((feature, index) => (
          <FeatureCard
            key={index}
            feature={feature}
            index={index}
            token={token}
          />
        ))}
      </div>

      {/* Main Content Section */}
      <div className="about-cont__mainContent">
        <MissionCard token={token} />

        {/* Two Column Layout */}
        <div className="about-cont__twoColumn">
          <TechnologyCard token={token} />
          <BenefitsCard
            impactPoints={impactPoints}
            token={token}
            borderColor={token?.colorSecondaryLogo}
            title="Key Benefits"
          />
        </div>

        <UnderstandingCard token={token} />
      </div>

      {/* Contact Us Section */}
      <ContactUs token={token} />
    </Content>
  );
}
